import ProjectCancelModalComponent from './project-cancel-modal.component'

const ProjectCancelModalModule = angular.module('cdbl.project.project-cancel-modal', [

])
  .component('cdblProjectCancelModal', ProjectCancelModalComponent)
  .name

export default ProjectCancelModalModule
